import { render, staticRenderFns } from "./fileDetail.vue?vue&type=template&id=2d4d5d88&"
import script from "./fileDetail.vue?vue&type=script&lang=js&"
export * from "./fileDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports